var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 70.8325V117.5",
    stroke: "#2D3282",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8558 27.5C42.2214 33.159 38.3442 40.3271 36.6918 48.1399C35.0393 55.9527 35.6822 64.0768 38.5428 71.5325L48.9547 99.02C51.3403 104.887 52.5451 111.167 52.5 117.5H67.5C67.4946 111.162 68.7303 104.884 71.1373 99.0201L81.4763 71.5326C84.3185 64.0789 84.9579 55.9653 83.3183 48.1584C81.6787 40.3515 77.8292 33.1805 72.2286 27.5",
    stroke: "#2D3282",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60 75.8325C62.7614 75.8325 65 73.5939 65 70.8325C65 68.0711 62.7614 65.8325 60 65.8325C57.2386 65.8325 55 68.0711 55 70.8325C55 73.5939 57.2386 75.8325 60 75.8325Z",
    fill: "#2D3282"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85 2.5V27.5H35V2.5",
    stroke: "#2D3282",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.528b8b007eff698d9d3c0a83ffd20a1b.svg";
export { ForwardRef as ReactComponent };